import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withKeys as _withKeys, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "form-check text-start" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 1,
  class: "spinner-border",
  style: {"width":"1rem","height":"1rem"},
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputComponent = _resolveComponent("InputComponent")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Modal = _resolveComponent("Modal")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(_component_Modal, {
    id: "modalValidationBird",
    "id-name": "modalValidationBird",
    onKeydown: _withKeys(_ctx.authUser, ["enter"])
  }, {
    "modal-header": _withCtx(() => [
      _createElementVNode("button", {
        id: "btnCloseModal",
        class: "btn-close",
        type: "button",
        "data-bs-dismiss": "modal",
        "aria-label": "Close",
        onClick: _cache[0] || (_cache[0] = () => _ctx.oeRecaptcha.hideBadge())
      })
    ]),
    "modal-body": _withCtx(() => [
      _cache[7] || (_cache[7] = _createElementVNode("h2", null, " Abra seu aplicativo Bird ID no seu celular e digite abaixo CPF e o código OTP do solicitante para prosseguir com a emissão. ", -1)),
      _createVNode(_component_InputComponent, {
        modelValue: _ctx.model.cpf,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.cpf) = $event)),
        label: "CPF",
        icon: "address-card",
        mask: ['###.###.###-##', ''],
        "error-log": _ctx.errors.cpf,
        placeholder: "Digite apenas números",
        "is-numeric": true
      }, null, 8, ["modelValue", "error-log"]),
      _withDirectives(_createVNode(_component_InputComponent, {
        modelValue: _ctx.model.otp,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.otp) = $event)),
        icon: "key",
        label: "OTP (Bird ID)",
        "error-log": _ctx.errors.otp,
        autocomplete: "off",
        placeholder: "Digite apenas números",
        "is-numeric": true
      }, null, 8, ["modelValue", "error-log"]), [
        [_directive_maska, ['### ###', '']]
      ]),
      _cache[8] || (_cache[8] = _createElementVNode("div", {
        id: "faqAccordion",
        class: "accordion"
      }, [
        _createElementVNode("div", { class: "accordion-item" }, [
          _createElementVNode("div", {
            id: "faqAccordionQuestionOne",
            class: "accordion-header"
          }, [
            _createElementVNode("button", {
              class: "btn accordion-button collapsed",
              type: "button",
              "data-bs-toggle": "collapse",
              "data-bs-target": "#faqAccordionAnswerOne",
              "aria-expanded": "false",
              "aria-controls": "faqAccordionAnswerOne"
            }, " Onde encontro o OTP? ")
          ]),
          _createElementVNode("div", {
            id: "faqAccordionAnswerOne",
            class: "accordion-collapse collapse",
            "aria-labelledby": "faqAccordionQuestionOne",
            "data-bs-parent": "#faqAccordion"
          }, [
            _createElementVNode("div", { class: "accordion-body text-start" }, [
              _createElementVNode("p", { class: "m-0" }, " Para gerar o código OTP, basta acessar o aplicativo BirdID no seu celular, fazer o login e digitar o número que aparece na sua tela inicial. ")
            ])
          ])
        ])
      ], -1)),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _withDirectives(_createElementVNode("input", {
            id: "default-checkbox",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.termos) = $event)),
            class: "form-check-input form-check-input--success",
            type: "checkbox"
          }, null, 512), [
            [_vModelCheckbox, _ctx.model.termos]
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("span", {
            class: "form-check-label me-1",
            for: "default-checkbox"
          }, " Li e concordo com a ", -1)),
          _cache[6] || (_cache[6] = _createElementVNode("a", {
            class: "link-info text-decoration-underline",
            href: "/PoliticadePrivacidade.pdf",
            target: "_blank"
          }, "política de privacidade ", -1))
        ])
      ])
    ]),
    "modal-footer": _withCtx(() => [
      _createElementVNode("button", {
        class: _normalizeClass(["btn", !_ctx.isValid ? 'btn-secondary' : 'btn-primary']),
        type: "button",
        disabled: !_ctx.isValid,
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.authUser && _ctx.authUser(...args)))
      }, [
        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "me-2" }, "Avançar", -1)),
        (!_ctx.loading)
          ? (_openBlock(), _createBlock(_component_Icon, {
              key: 0,
              name: "arrow-right"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_3))
      ], 10, _hoisted_2)
    ]),
    _: 1
  }, 8, ["onKeydown"]))
}